import axios from 'axios';

const API = process.env.VUE_APP_API_URL;
const axiosConfig = {withCredentials: true};

export default function (route) {
    const path = API + route;
    const path_id = (path, id) => path + "/" + id;

    return {
        getAll(config = axiosConfig) {
            return axios.get(path, config);
        },
        get(id, config = axiosConfig) {
            return axios.get(path_id(path, id), config);
        },
        post(data = {}, config = axiosConfig) {
            return axios.post(path, data, config);
        },
        put(id, data = {}, config = axiosConfig) {
            return axios.put(path_id(path, id), data, config);
        },
        delete(id, config = axiosConfig) {
            return axios.delete(path_id(path, id), config);
        }
    }
}
